/**
 * Validates and normalizes text for campaign URL
 * - Allows only letters, numbers, hyphens, and underscores
 * - Replaces spaces with hyphens
 * - Removes invalid characters
 * - Optionally truncates to specified length
 * @param text Text to be validated
 * @param size Optional maximum character length
 * @returns Normalized text or undefined if invalid
 */
export const formatCampaignCode = (
  text: string,
  size?: number
): string | undefined => {
  if (!text || typeof text !== "string") return undefined;

  // Step 0: Convert to lowercase
  let normalized = text.toLocaleLowerCase();

  // Step 1: Replace spaces with hyphens
  normalized = normalized.replace(/\s+/g, "-");

  // Step 2: Remove invalid characters
  normalized = normalized.replace(/[^a-z0-9-_]/g, "");

  // Step 3: Remove sequential hyphens and underscores
  normalized = normalized.replace(/-+/g, "-");
  normalized = normalized.replace(/_+/g, "_");

  // Step 4: Remove hyphens/underscores at the beginning
  normalized = normalized.replace(/^[-_]+/g, "");

  // Step 5: Truncate to specified size if provided
  if (size !== undefined && size > 0 && normalized.length > size) {
    normalized = normalized.substring(0, size);

    // Remove any trailing hyphen or underscore after truncation
    normalized = normalized.replace(/[-_]+$/, "");
  }

  return normalized || undefined;
};

/**
 * Retorna se um caractere é uma Letra, Número ou, caso contrário, Falso
 * @param value Caractere a ser validado
 * @returns Número, Letra ou FALSE
 */
export const isStringOrNumber = (value: string): any | boolean => {
  if (/^[0-9]+$/.test(value)) {
    return "Número";
  } else if (/^[a-zA-Z]+$/.test(value)) {
    return "Letra";
  } else {
    return false;
  }
};
